import { useCallback } from 'react';
import { useStore } from 'react-redux';
import type { RootState } from '@/app/store/index';
import { RetiredSaveError, type QuoteConflictError } from '../services/quoteSaveErrors';
import type { QuoteSaveLaneApi } from './useQuoteSaveLane';

export interface InitiationTicket {
    expectedVersion: number | undefined;
    settle: (conflict: QuoteConflictError | null) => void;
}

export function useInitiationPrecondition(
    saveLane: Pick<QuoteSaveLaneApi, 'guard' | 'reportConflict'>
): () => InitiationTicket {
    const store = useStore<RootState>();
    const { guard, reportConflict } = saveLane;

    return useCallback(() => {
        const expectedVersion = store.getState().quote.version;
        let settle: InitiationTicket['settle'] = () => undefined;
        const outcome = new Promise<QuoteConflictError | null>((resolve) => {
            settle = resolve;
        });
        guard(async (ensureOwned) => {
            const conflict = await outcome;
            ensureOwned();
            if (conflict) reportConflict(conflict);
        }).catch((error: unknown) => {
            if (error instanceof RetiredSaveError) return;
            throw error;
        });
        return { expectedVersion, settle };
    }, [store, guard, reportConflict]);
}
